import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import {
  useHasOrganizationUpdatePermissions,
  useHasProjectSettingsPermissionForAnyProjectInOrg,
} from '@monorepo/shared/hooks/permissions/useHasPermissions';
import React from 'react';
import { Route, useParams } from 'react-router-dom';
import { Loading } from '../../shared/componentsV2/Loading';
import { useLinkOnSameOrg } from '../../shared/hooks/navigation/useLinkOnSame/useLinkOnSameOrg';
import { ViewFormsPage } from './components/ViewFormsPage/ViewFormsPage';
import { FormTemplateWizardRouter } from './FormTemplateWizardRouter';

export function FormsDataSetupRouter() {
  const { organizationId } = useParams();

  const hasOrgUpdatePermissions =
    useHasOrganizationUpdatePermissions(organizationId);
  const { isLoading: isLoadingPermissions, isAdminOnAnyProjectInOrg } =
    useHasProjectSettingsPermissionForAnyProjectInOrg(organizationId);

  const formWizardBasePath = useLinkOnSameOrg('/data-setup/forms');

  if (isLoadingPermissions) {
    return <Loading />;
  }

  return (
    <RoutesWith404>
      <>
        <Route
          index
          element={
            <ErrorBoundary>
              <ViewFormsPage />
            </ErrorBoundary>
          }
        />
        {hasOrgUpdatePermissions && (
          <Route
            path="new/*"
            element={
              <FormTemplateWizardRouter
                isUsingOrgSpecificEditor
                hasOrgUpdatePermissions={hasOrgUpdatePermissions}
                formWizardBasePath={formWizardBasePath}
                isEditMode={false}
              />
            }
          />
        )}
      </>
      {isAdminOnAnyProjectInOrg && (
        <Route
          path=":formTemplateSlug/edit/*"
          element={
            <FormTemplateWizardRouter
              isUsingOrgSpecificEditor
              hasOrgUpdatePermissions={hasOrgUpdatePermissions}
              formWizardBasePath={formWizardBasePath}
              isEditMode
            />
          }
        />
      )}
    </RoutesWith404>
  );
}
